module.exports = __webpack_public_path__ + "static/media/project_1.9f886b0d.webp";